'use client'

import { createContext } from 'react'
import { SessionType } from '../../utility/model/sessionType'

export const SessionContext = createContext<SessionType | undefined>({
  user: null,
})

export function SessionProvider({
  session,
  children,
}: Readonly<{
  session: SessionType | undefined
  children: React.ReactNode
}>) {
  return (
    <SessionContext.Provider
      value={
        session ?? {
          user: null,
        }
      }
    >
      {children}
    </SessionContext.Provider>
  )
}
